/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityFindingNativeDetailsBaseForCloud extends models.SecurityFindingNativeDetailsBase {
    constructor() {
        super();
        this.setDiscriminator("SecurityFindingNativeDetailsBaseForCloud");
    }

    getFixupPrototypeFunction() { return SecurityFindingNativeDetailsBaseForCloud.fixupPrototype; }

    static newInstance(model: Partial<SecurityFindingNativeDetailsBaseForCloud>): SecurityFindingNativeDetailsBaseForCloud {
        let obj = Object.assign(new SecurityFindingNativeDetailsBaseForCloud(), model);
        SecurityFindingNativeDetailsBaseForCloud.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityFindingNativeDetailsBaseForCloud>): SecurityFindingNativeDetailsBaseForCloud {
        if (!model) return null;
        return SecurityFindingNativeDetailsBaseForCloud.newInstance(<SecurityFindingNativeDetailsBaseForCloud> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityFindingNativeDetailsBaseForCloud) {
        if (!obj) return;

        models.SecurityFindingNativeDetailsBaseForCloud.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityFindingNativeDetailsBaseForCloud): boolean {
        if (models.SecurityFindingNativeDetailsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, SecurityFindingNativeDetailsBaseForCloud.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.detected_at === "string") {
            this.detected_at = new Date(<string><any>this.detected_at);
        }
    }

    /**
     * Unique identifier of the cloud resource where the security finding was detected
     */
    resource_id: string;

    /**
     * High-level category classification of the cloud resource (e.g., compute, storage, network)
     */
    resource_category: string;

    /**
     * Specific type of cloud resource (e.g., EC2 instance, S3 bucket, RDS database)
     */
    resource_type: string;

    /**
     * Human-readable name or identifier of the specific cloud resource instance
     */
    resource: string;

    /**
     * Internal inventory system identifier for tracking the cloud resource
     */
    inventory_id: string;

    /**
     * Unique identifier of the tenant organization that owns the resource
     */
    tenant_id: string;

    /**
     * Identifier of the cloud service account used to access and scan the resource
     */
    service_account_id: string;

    /**
     * Identifier of the original service account when using delegate or cross-account access (e.g., AWS Inspector)
     */
    source_service_account_id: string;

    /**
     * Original finding identifier as provided by the external security scanning tool
     */
    finding_id: string;

    /**
     * Classification type of the security finding as defined by the external scanning tool
     */
    finding_type: string;

    /**
     * Geographic region or availability zone where the cloud resource is located
     */
    region: string;

    /**
     * Logical grouping or organizational unit containing the cloud resource
     */
    resource_group: string;

    /**
     * Internal reference identifier linking to detailed vulnerability information
     */
    vulnerability_id: string;

    /**
     * Timestamp indicating when the security finding was first detected by the scanning tool
     */
    detected_at: Date;

    /**
     * Complete raw data payload from the external security tool containing all original finding details
     */
    source_data: any;

}
